<script>
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useModalStore } from "@/stores/modal.js";
import { useGarageStore } from "@/stores/garage.js";

export default {
  setup() {
    // I18n
    const { t } = useI18n();
    const translationPrefix = ref('modal.vehicle_info');

    // Stores
    const modalStore = useModalStore();
    const garageStore = useGarageStore();

    // Variables
    const isLoading = ref(true);

    onMounted(async () => {});

    return {
      t,
      translationPrefix,
      modalStore,
      garageStore,
      isLoading,
    }
  },
};
</script>

<template>
  <div class="flex flex-col space-y-4 w-full px-8 py-4">
    <div class="w-full">
      <p class="font-semibold text-lg modal-header">{{ t(`${translationPrefix}.modal_body`) }}</p>
      <p class="text-md text-gray-600">{{ t(`${translationPrefix}.modal_body_text`) }}</p>
    </div>
    <div class="w-full">
      <label for="vehicle_nickname" class="block text-gray-600 font-semibold">{{ t(`${translationPrefix}.vehicle_nickname_label`) }}</label>
      <input type="text" id="vehicle_nickname" name="vehicle_nickname" v-model="modalStore.newVehicle.nickname" class="w-full mt-1 p-2 px-4 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-purple-300" :placeholder="t(`${translationPrefix}.vehicle_nickname_placeholder`)">
    </div>
    <div class="w-full">
      <label for="vehicle_description" class="block text-gray-600 font-semibold">{{ t(`${translationPrefix}.vehicle_description_label`) }}</label>
      <textarea id="vehicle_description" name="vehicle_description" v-model="modalStore.newVehicle.description" class="w-full mt-1 p-2 px-4 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-purple-300" :placeholder="t(`${translationPrefix}.vehicle_description_placeholder`)" />
    </div>
    <div class="w-full">
      <label for="vehicle_modifications" class="block text-gray-600 font-semibold">{{ t(`${translationPrefix}.vehicle_modification_label`) }}</label>
      <textarea id="vehicle_modifications" name="vehicle_modifications" v-model="modalStore.newVehicle.modifications" class="w-full mt-1 p-2 px-4 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-purple-300" :placeholder="t(`${translationPrefix}.vehicle_modification_placeholder`)" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/styles/components/modals/garage';
</style>
